export const aboutData = {
    title: "Who I am",
    description1: "My name's Ritik. I'm a web designer and developer based in New Delhi, India.",
    description2: "I am a tech enthusiast who loves to explore new technologies.My interset lies in Web development and problem solving.",
    image: 2
}